import { IOptionalText } from './IOptionalText';
import { AnswerMap } from '../AnswerMap';


export class OptionalText {
  rule: string;

  text: string;

  constructor(sourceOptional: IOptionalText) {
    this.rule = sourceOptional.rule;
    this.text = sourceOptional.text;
  }

  public static convertArray(sourceOptionals: IOptionalText[] | undefined): OptionalText[] {
    const optionalArray: OptionalText[] = [];
    if (sourceOptionals) {
      sourceOptionals.forEach((element) => {
        optionalArray.push(new OptionalText(element));
      });
    }
    return optionalArray;
  }

  public static evaluateOptionalText(settings: AnswerMap, optionals: OptionalText[], defaultText: string) {
    let text: string = defaultText;

    if (optionals.length > 0) {
      const settingsMap: Map<string, string | string[] | boolean | undefined> = new Map<string, string | string[] | boolean | undefined>(Object.entries(settings));

      for (let i = 0; i < optionals.length; i++) {
        if (optionals[i].evaluateOption(settingsMap)) {
          text = optionals[i].text;
          break;
        }
      }
    }

    return text;
  }

  private evaluateOption(settings: Map<string, string | string[] | boolean | undefined>): boolean {
    /* eslint-disable no-new-func */
    const result = Function('settings', `return ${this.rule}`)(settings);
    /* eslint-enable no-new-func */
    return result;
  }
}

export default OptionalText;
